import { Beacon } from '../Beacon';
import { AdserverRequestId, BeaconType } from '../types';
import { getBaseParams } from '../utils/getBaseParams';

export const dispatchImpressionReceived = (arid: AdserverRequestId) => {
  return new Beacon({
    data: {
      type: BeaconType.impressionReceived,
      arid,
      ...getBaseParams(arid)
    }
  });
};
